module.exports = __webpack_public_path__ + "media/images/dryer-d7981e2646e4cf7407df25e25e96af99.svg";